var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4002 8.88772V5.08218C17.4002 4.17767 17.4002 3.72541 17.2097 3.44747C17.0432 3.20464 16.7854 3.03969 16.4951 2.9903C16.1629 2.93377 15.7523 3.12329 14.931 3.50234L5.28437 7.95464C4.55193 8.29269 4.18571 8.46171 3.91749 8.72386C3.68036 8.9556 3.49935 9.2385 3.38831 9.55091C3.2627 9.90431 3.2627 10.3076 3.2627 11.1143V16.5002M17.9439 15.9565H17.9548M3.2627 12.3677L3.2627 19.5452C3.2627 20.7633 3.2627 21.3724 3.49976 21.8377C3.70828 22.2469 4.04101 22.5796 4.45027 22.7882C4.91552 23.0252 5.52458 23.0252 6.7427 23.0252H19.3577C20.5758 23.0252 21.1849 23.0252 21.6501 22.7882C22.0594 22.5796 22.3921 22.2469 22.6006 21.8377C22.8377 21.3724 22.8377 20.7633 22.8377 19.5452V12.3677C22.8377 11.1496 22.8377 10.5406 22.6006 10.0753C22.3921 9.66604 22.0594 9.33331 21.6501 9.12478C21.1849 8.88772 20.5758 8.88772 19.3577 8.88772L6.7427 8.88772C5.52458 8.88772 4.91552 8.88772 4.45027 9.12478C4.04101 9.33331 3.70828 9.66604 3.49976 10.0753C3.2627 10.5406 3.2627 11.1496 3.2627 12.3677ZM18.4877 15.9565C18.4877 16.2568 18.2442 16.5002 17.9439 16.5002C17.6436 16.5002 17.4002 16.2568 17.4002 15.9565C17.4002 15.6562 17.6436 15.4127 17.9439 15.4127C18.2442 15.4127 18.4877 15.6562 18.4877 15.9565Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.4beb0b70245e8283d6d646958c68f2e8.svg";
export { ForwardRef as ReactComponent };